import request from '../utils/request'

/**
 * 获取注册验证码
 */
export function getIc () {
  return request.get('/ic')
}
